import { useState } from "react";
import {
  selectCurrentSiVoteGraphData,
  selectCurrentTownData,
} from "../../store/appSlice";
import {
  BtnHowToGraph,
  GraphLabel,
  GraphWinnerTitle,
  Icon,
  Modal,
  ModalDimmed,
  Paragraph,
  ParagraphWithGraphLabel,
  Subtitle,
  TextHowToGraph,
  TitleHowToGraph,
  WrapHowToGraph,
} from "../style/styled";
import { CompVoteDirGraph } from "./CompVoteDirGraph";
import { useSelector } from "react-redux";
import {
  CompTextHitRate,
  CompTextSynchroRate,
  CompTextVoteDir,
  CompTextVoteDirTwo,
} from "./CompText";
import { CompRelatedArticle } from "./CompRetlatedArticle";
import { IMG_URL, LIST_CANDIDATE, LIST_CANDIDATE_PARTY } from "../../constant";
import { CompBtnClose, CompBtnLinkWithIcon } from "./CompIconBtn";

export function CompMore() {
  const {
    sido,
    sgg,
    winner_16,
    winner_value_16,
    winner_17,
    winner_value_17,
    winner_18,
    winner_value_18,
    winner_19,
    winner_value_19,
    count_winner,
    sync_per,
    syncper_19,
    best_shift_18_19,
    syncper_19_rank,
    first,
    second,
    third,
  } = useSelector(selectCurrentTownData);
  const currentSiGraph = useSelector(selectCurrentSiVoteGraphData);
  const currentTownGraph = currentSiGraph.filter((item) => item.sgg === sgg);
  const townName = `${sido}-${sgg}`;
  const [isHowToGraphModal, setIsHowToGraphModal] = useState(false);
  const onSelectIsHowToGraphModal = () =>
    setIsHowToGraphModal(!isHowToGraphModal);
  const COLOR = { BOSU: "#FF0000", JINBO: "#0077C1" };

  const isColor = (item) => (item === 1 ? COLOR.BOSU : COLOR.JINBO);
  return (
    <>
      <Icon>
        <img src={`${IMG_URL}/icon1.png`} alt="icon" />
      </Icon>
      <Subtitle>{sgg}의 적중률</Subtitle>
      <CompTextHitRate
        town={townName}
        winner_16={winner_16}
        winner_value_16={winner_value_16}
        winner_17={winner_17}
        winner_value_17={winner_value_17}
        winner_18={winner_18}
        winner_value_18={winner_value_18}
        winner_19={winner_19}
        winner_value_19={winner_value_19}
        count_winner={count_winner}
        sync_per={sync_per}
      />
      <CompBtnLinkWithIcon
        link="https://www.youtube.com/watch?v=g6iQlenn8i0"
        text="2030 밀집 동네 표심, 21대 총선부터 '변화'"
      />
      <Icon>
        <img src={`${IMG_URL}/icon2.png`} alt="icon" />
      </Icon>
      <Subtitle>{sgg}의 싱크로율</Subtitle>
      <CompTextSynchroRate
        town={townName}
        syncper_19={syncper_19}
        syncper_19_rank={syncper_19_rank}
      />
      <CompBtnLinkWithIcon
        link="https://www.youtube.com/watch?v=BBLVH1SwkKA"
        text="역대 대선 다 맞힌 '천기누설 동네'는 어디?"
      />
      <Icon>
        <img src={`${IMG_URL}/icon2.png`} alt="icon" />
      </Icon>
      <Subtitle>{sgg}의 민심의 바람</Subtitle>
      <CompTextVoteDir first={first} />
      <Icon>
        <img src={`${IMG_URL}/icon3.png`} alt="icon" />
      </Icon>
      <CompTextVoteDirTwo
        sido={sido}
        second={second}
        third={third}
        best_shift_18_19={best_shift_18_19}
      />
      <Subtitle style={{ marginBottom: "5px" }}>
        {sido} {sgg}
      </Subtitle>
      <GraphWinnerTitle>
        최근 표심은 문재인 후보 쪽으로 +{Math.floor(third.percent * 100)}
        %p
      </GraphWinnerTitle>

      <ParagraphWithGraphLabel>
        <GraphLabel>
          <span>17대</span>
          <span>18대</span>
          <span>19대</span>
        </GraphLabel>
        <CompVoteDirGraph data={currentTownGraph} />
      </ParagraphWithGraphLabel>
      <BtnHowToGraph onClick={onSelectIsHowToGraphModal}>
        그래프 보는법 자세히 보기
      </BtnHowToGraph>
      {isHowToGraphModal && (
        <ModalDimmed onClick={() => setIsHowToGraphModal(false)}>
          <Modal>
            <WrapHowToGraph>
              <TitleHowToGraph>그래프 보는법</TitleHowToGraph>
              <img
                src={`${IMG_URL}/howtounderstandGraph.png`}
                alt="그래프 읽는법"
              />
              <div style={{ textAlign: "left" }}>
                <TextHowToGraph>
                  지난 4번의 선거에서의 득표율 변화를 시각화했습니다.
                  오른쪽(빨간색)으로 향하면 보수 후보 쪽으로, 왼쪽(파란색)으로
                  향하면 진보 후보 쪽으로 득표율(%p) 변화가 발생했다는
                  의미입니다. 막대의 길이는 득표율 차이와 비례합니다. 막대 끝의
                  점 색은 득표율 1위 후보의 정당을 뜻합니다.
                </TextHowToGraph>
              </div>
              <CompBtnClose onClick={onSelectIsHowToGraphModal}></CompBtnClose>
            </WrapHowToGraph>
          </Modal>
        </ModalDimmed>
      )}
      <Paragraph>
        <CompVoteDirGraph data={currentSiGraph} />
      </Paragraph>
      <CompRelatedArticle />
    </>
  );
}
